<h1 mat-dialog-title>{{data.title?data.title:'Carica file' | translate}}</h1>
<mat-dialog-content>
  @if (loading) {
    <mat-progress-bar class='mt-24 mb-24' style='min-width:300px' mode="indeterminate"></mat-progress-bar>
  }

  <div [innerHTML]="data.message"></div>

  <div class='file-input-controller'>
    @if (!formGroup.get("file").value) {
      <div class='file-drop-zone' [class.dragging]='dragging' (dragleave)='onFileDragLeave($event)' (dragstart)='onFileDragStart($event)' (dragover)='onFileDragOver($event)' (drop)='onFileDrop($event)'>
        <div class="fx-column fx-justify-center fx-items-center">
          <mat-icon color='accent'>cloud_download</mat-icon>
          <span><strong>{{'Trascina il file qui per caricarlo' | translate}}</strong></span>
          <span>{{'oppure clicca per cercare nel computer' | translate}}</span>
          <span>{{'Sono supportati i file: .jpeg, .png' | translate}}</span>
          @if (imageWidth && imageHeight) {
            <span>
              {{'Formato' | translate}}: {{imageWidth}} x {{imageHeight}}
            </span>
          }
        </div>
        <input #fileInput (change)="onFileChange($event)" type='file'/>
      </div>
    }
    @if (imageChangedEvent && svgEnablded) {
      <div class='file-loaded'>
        @if (fileType !== "image") {
          <div class="fx-column fx-justify-center fx-items-center">
            <mat-icon color='accent'>insert_drive_file</mat-icon>
            @if (selectedFileName) {
              <span>{{selectedFileName}}</span>
            }
          </div>
        }
        @if (imagePreviewSrc) {
          <img class='file-loaded-preview' [src]="imagePreviewSrc" alt='preview' />
        }
        <button class='file-loaded-remove-btn' mat-icon-button (click)='clearFile()'>
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }
    @if (imageChangedEvent && !svgEnablded) {
      <div class='file-loaded'>
        @if (fileType !== "image") {
          <div class="fx-column fx-justify-center fx-items-center">
            <mat-icon color='accent'>insert_drive_file</mat-icon>
            @if (selectedFileName) {
              <span>{{selectedFileName}}</span>
            }
          </div>
        }
        <!--<img *ngIf='imagePreviewSrc' class='file-loaded-preview' [src]='imagePreviewSrc' alt='preview' />-->
        @if (fileType === "image") {
          <image-cropper
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="true"
            [aspectRatio]="imageRatio"
            [resizeToWidth]="imageWidth"
            [resizeToHeight]="imageHeight"
            [cropperMinWidth]="imageWidth"
            [cropperMinHeight]="imageHeight"
            [onlyScaleDown]="true"
            [roundCropper]="false"
            [autoCrop]="true"
            format="png"
            (imageCropped)="imageCropped($event)"
            (imageLoaded)="imageLoaded()"
            (cropperReady)="cropperReady()"
            (loadImageFailed)="loadImageFailed()"
          ></image-cropper>
        }
        <button class='file-loaded-remove-btn' mat-icon-button (click)='clearFile()'>
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align='end'>
  <button mat-button (click)="onNoClick()">{{data.negativeText?data.negativeText:'Annulla' | translate}}</button>
  <button mat-flat-button (click)='onUpload()' [disabled]='loading' color='accent' >{{data.positiveText?data.positiveText:'Carica' | translate}}</button>
</mat-dialog-actions>
